import { Button } from '@unlimitai/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import api from '@/apis/api';
import { submitInteraction } from '@/apis/experience/interaction';

import { errorMessage } from './error';
import styles from './index.module.scss';

const BusinessCompletion = () => {
  const { state }: { state: unknown } = useLocation();
  const [error, setError] = useState(
    state &&
      typeof state === 'object' &&
      'businessError' in state &&
      typeof state.businessError === 'string'
      ? state.businessError
      : ''
  );
  const [busy, setBusy] = useState(false);
  const { i18n } = useTranslation();
  const zh = i18n.language.startsWith('zh');
  const finish = async (shouldDeferOrganization: boolean) => {
    setBusy(true);
    try {
      if (shouldDeferOrganization) {
        await api.post('/api/experience/business-intent/skip-organization', { retry: 0 });
      }
      const { redirectTo } = await submitInteraction();
      window.location.assign(redirectTo);
    } catch (error_: unknown) {
      setError(await errorMessage(error_));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className={styles.form}>
      <h1>{zh ? '完成账号设置' : 'Complete account setup'}</h1>
      <p>
        {zh
          ? '身份验证已通过，业务设置尚未完成。重试会复用当前账号，不会重新注册。'
          : 'Authentication succeeded, but account setup is incomplete. Retry with the same account.'}
      </p>
      {error && (
        <p role="alert" className={styles.error}>
          {error}
        </p>
      )}
      <Button
        disabled={busy}
        onClick={() => {
          void finish(false);
        }}
      >
        {zh ? '重试完成设置' : 'Retry setup'}
      </Button>
      <Button
        variant="ghost"
        disabled={busy}
        onClick={() => {
          void finish(true);
        }}
      >
        {zh ? '仅登录，稍后处理组织设置' : 'Sign in and finish organization setup later'}
      </Button>
      <p className={styles.hint}>
        {zh
          ? '不会变更已有的组织归属；未完成的组织设置仍可稍后重试。'
          : 'Existing memberships remain unchanged. Pending organization setup can be retried later.'}
      </p>
    </section>
  );
};
export default BusinessCompletion;
